export default __webpack_public_path__ + "static/media/ford-oval.19cf1764.svg";